module.exports = __webpack_public_path__ + "Flag-604.8768ebd400b3e3eee24deb040e00802a.svg";